<---图书-摄友 一个项目一个链接 -->
<template>
  <div class="container" v-if="isShow">
    <img :src="currentBg" alt="" class="img" />
    <div
      class="input-container"
      :class="{ aqs: shortName == 'aqs', jjs: shortName == 'jjs', jzs1: shortName == 'jzs1', jzs2ydt: shortName == 'jzs2ydt', ky: shortName == 'ky' }"
    >
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入您的手机号，仅开课使用，已加密" v-model="formData.mobile" />
      </div>
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <div class="radio-wrapper">
        <div class="radio-item" v-for="(item, index) in filterList" :key="index" @click="radioChange(index)">
          <img src="@/assets/imgs/check_box_selected.png" v-if="item.isSelected" />
          <img src="@/assets/imgs/check_box.png" v-else />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="submit" @click="onsubmit" />
    </div>
  </div>
</template>

<script>
import { enrollPwd, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      codeTime: 60,
      formData: {
        mobile: '',
        msg: ''
      },
      list: [
        {
          name: '建筑全科',
          shortName: 'jzs2',
          id: 'BK202407030013',
          promotedAccount: '图书-摄友-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: '21555442383e42fcb42459aab1c62ea4',
              subjectid: '3bdfeeff79834aa08cf1f34f68143cbd'
            }
          ]
        },
        {
          name: '机电全科',
          shortName: 'jzs2',
          id: 'BK202407030015',
          promotedAccount: '图书-摄友-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: '0812142007184fb0ab3ac7c540e37726',
              subjectid: '0137751bebf94548a39f4c78ab8caa20'
            }
          ]
        },
        {
          name: '市政全科',
          shortName: 'jzs2',
          id: 'BK202407030014',
          promotedAccount: '图书-摄友-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: '420032a720994e18b2cf6ad736fc48bb',
              subjectid: '704086d0180f439d882cb671c232e9ce'
            }
          ]
        },
        {
          name: '公路全科',
          shortName: 'jzs2',
          id: 'BK202407030016',
          promotedAccount: '图书-摄友-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: 'c43d58ead8094395882393223ca7f37f',
              subjectid: '9f6a0901dd8746d3ac6ec25669f05482'
            }
          ]
        },
        {
          name: '水利全科',
          shortName: 'jzs2',
          id: 'BK202407030017',
          promotedAccount: '图书-摄友-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: 'd7b22798a14d4bb28032d5d985481dac',
              subjectid: 'dd28111117f141afb53192d079fa2bc0'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'jzs1',
          id: 'BK202407030001',
          promotedAccount: '图书-摄友-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: '8bd13e79040a4416af5d77aa7b81b340',
              subjectid: '69e46917cfdf4fa1a103ce044b368051'
            }
          ]
        },
        {
          name: '机电全科',
          shortName: 'jzs1',
          id: 'BK202407030003',
          promotedAccount: '图书-摄友-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: '5514ee0d5fdf4f04882ba09ba476d286',
              subjectid: '8c0126ad336c470ab786631fd3a0b64e'
            }
          ]
        },
        {
          name: '市政全科',
          shortName: 'jzs1',
          id: 'BK202407030002',
          promotedAccount: '图书-摄友-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: 'c1ad283921964739bcb406b6968462cc',
              subjectid: '7b44758158d24726ab0a3a627c1e4c84'
            }
          ]
        },
        {
          name: '公路全科',
          shortName: 'jzs1',
          id: 'BK202407030004',
          promotedAccount: '图书-摄友-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: 'fa9cc21b6dc541e993086a4db30eca66',
              subjectid: 'fb34520de9d046ee93a974f0b1e2642b'
            }
          ]
        },
        {
          name: '水利全科',
          shortName: 'jzs1',
          id: 'BK202407030005',
          promotedAccount: '图书-摄友-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: '3b0f58d15d694bc89357eb1ad2927386',
              subjectid: '7a57c2fdc74b465aa3810a456958c781'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'jzs2ydt',
          id: 'BK202411160001',
          promotedAccount: '图书-摄友-二建一点通',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: '1dfa64534b4a4186b31daae7c1d5042e',
              subjectid: '3bdfeeff79834aa08cf1f34f68143cbd'
            }
          ]
        },
        {
          name: '机电全科',
          shortName: 'jzs2ydt',
          id: 'BK202411160001',
          promotedAccount: '图书-摄友-二建一点通',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: 'bb100ccfa29d4672896dff0b6db7cdee',
              subjectid: '0137751bebf94548a39f4c78ab8caa20'
            }
          ]
        },
        {
          name: '市政全科',
          shortName: 'jzs2ydt',
          id: 'BK202411160001',
          promotedAccount: '图书-摄友-二建一点通',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: 'a249d2fc3b5b41abb2c702c625dffdc1',
              subjectid: '704086d0180f439d882cb671c232e9ce'
            }
          ]
        },
        {
          name: '公路全科',
          shortName: 'jzs2ydt',
          id: 'BK202411160001',
          promotedAccount: '图书-摄友-二建一点通',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: '45bffe73abf34f20a1a80ea71764e5b0',
              subjectid: '9f6a0901dd8746d3ac6ec25669f05482'
            }
          ]
        },
        {
          name: '水利全科',
          shortName: 'jzs2ydt',
          id: 'BK202411160001',
          promotedAccount: '图书-摄友-二建一点通',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: '00f74ee58fff49b1acc886d051845f0a',
              subjectid: 'dd28111117f141afb53192d079fa2bc0'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'aqs',
          id: 'BK202407030006',
          promotedAccount: '图书-摄友-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '建筑施工安全全科',
              worthid: '2c61060933854dfea04386925a983f06',
              subjectid: '6d50bafdbf2b40ffa4eb85bb861d4ace'
            }
          ]
        },
        {
          name: '化工全科',
          shortName: 'aqs',
          id: 'BK202407030007',
          promotedAccount: '图书-摄友-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '化工安全全科',
              worthid: '4a642ef716c146fea914a9abd003b862',
              subjectid: 'a7c4f50d5ce94eef9ee8880ca2f4cc71'
            }
          ]
        },
        {
          name: '煤矿全科',
          shortName: 'aqs',
          id: 'BK202407030009',
          promotedAccount: '图书-摄友-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '煤矿安全全科',
              worthid: 'dd233f05533a476aaace13e31f692679',
              subjectid: '63a0aa33686b4a56b4477f8696f716e8'
            }
          ]
        },
        {
          name: '其他安全全科',
          shortName: 'aqs',
          id: 'BK202407030008',
          promotedAccount: '图书-摄友-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '其他安全全科',
              worthid: '3b3bbdb363854f9eb75d7ad5f3ee10dc',
              subjectid: '5382d9e80806476999073b88290cac58'
            }
          ]
        },
        {
          name: '道路运输全科',
          shortName: 'aqs',
          id: 'BK202407030012',
          promotedAccount: '图书-摄友-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '道路运输安全全科',
              worthid: '509b85a82686428295cefc3d76171208',
              subjectid: '0d9d3c77fe5b4aabb3c2d8d7da814279'
            }
          ]
        },
        {
          name: '金属冶炼全科',
          shortName: 'aqs',
          id: 'BK202407030011',
          promotedAccount: '图书-摄友-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '金属冶炼全科',
              worthid: 'c962cde79b8b4cb1addd6869696f17e3',
              subjectid: '89f5ce69ccf04c529ac91ed959c695e9'
            }
          ]
        },
        {
          name: '金属非金属全科',
          shortName: 'aqs',
          id: 'BK202407030010',
          promotedAccount: '图书-摄友-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '金属非金属全科',
              worthid: '5d409365726f4e8e868c247d9b16e276',
              subjectid: 'e0eed484583c49a2817a1b9cd225784b'
            }
          ]
        },
        {
          name: '工商全科',
          shortName: 'jjs',
          id: 'BK202408140001',
          promotedAccount: '图书-摄友-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '工商管理全科',
              worthid: '5fb55504a83b49ffae36823f04b89d33',
              subjectid: 'd486254753064e4ea9c0208ea078b6b1'
            }
          ]
        },
        {
          name: '人力全科',
          shortName: 'jjs',
          id: 'BK202408140001',
          promotedAccount: '图书-摄友-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '人力资源全科',
              worthid: '80acac6df79c4ba09c7d116c7f36162d',
              subjectid: 'f2614ddc9da14247820b0a4f877a8ea8'
            }
          ]
        },
        {
          name: '财税全科',
          shortName: 'jjs',
          id: 'BK202408140001',
          promotedAccount: '图书-摄友-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '财政税收全科',
              worthid: 'ca7fd2432a9d4799aafdb52469581700',
              subjectid: '353eee8c648e414e9484673cfc8336eb'
            }
          ]
        },
        {
          name: '金融全科',
          shortName: 'jjs',
          id: 'BK202408140001',
          promotedAccount: '图书-摄友-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '金融全科',
              worthid: 'b15f38820c4242d8be55bc3ed7e575a9',
              subjectid: 'df80ab10f09e4cdfb17d4f6ebc038836'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'jjs',
          id: 'BK202408140001',
          promotedAccount: '图书-摄友-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '建筑与房地产全科',
              worthid: '064b03d5997d4d1293e929aea24360a3',
              subjectid: 'dd8f7c27d2d543feb30f558f00cd7683'
            }
          ]
        },
        {
          name: '管理专硕',
          shortName: 'ky',
          id: 'BK202405290001',
          promotedAccount: '图书-摄友-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语二+管综',
              worthid: 'dc90b91a611b4cde8f73b3a7e4a7c8bf',
              subjectid: '6c1095e7c99c4e5397a57d575a2db3e5'
            }
          ]
        },
        {
          name: '教育专硕',
          shortName: 'ky',
          id: 'BK202406180004',
          promotedAccount: '图书-摄友-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语一+政治+教育综合',
              worthid: 'b97eafdd85f24d65bb27bf0d9f16b025',
              subjectid: 'b5fee91a139d41a2ae33ceddc4c24e72'
            },
            {
              name: '英语二+政治+教育综合',
              worthid: 'd9222f377ca440d09be9dd03fa5cff69',
              subjectid: '8f6f0bbf333a453889b5a19a0175614b'
            }
          ]
        },
        {
          name: '护理/护理学',
          shortName: 'ky',
          id: 'BK202406180005',
          promotedAccount: '图书-摄友-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语一+政治+护理综合',
              worthid: '72ec7ea2e9244aa5a00273b0512dad55',
              subjectid: '2b7765fafbcd4879a5efe710f6ebe0bc'
            }
          ]
        },
        {
          name: '应用心理',
          shortName: 'ky',
          id: 'BK202406180008',
          promotedAccount: '图书-摄友-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语一+政治+心理学综合',
              worthid: 'd20a18cf965f43e4b36dfc6239dda3a1',
              subjectid: '4eef0d0b666043989e93abc06aed1791'
            },
            {
              name: '英语二+政治+心理学综合',
              worthid: '09bb4151f49e442092c52c13f9c99dd4',
              subjectid: 'c9e4bf34acf84120992c87c73f72f79a'
            }
          ]
        },
        {
          name: '临床医学(西医)',
          shortName: 'ky',
          id: 'BK202406180006',
          promotedAccount: '图书-摄友-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语（一）',
              worthid: '102b4d6eb3564eb6bfe6f34de203bdb8',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '思想政治理论',
              worthid: '12f06d48e165474a8a2ff36c6d742dd4',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            },
            {
              name: '临床医学综合能力(西医)',
              worthid: '354e0d7334684bbe8708d7ff974366b0',
              subjectid: '3f13dafd598947d2800124b3cf6cd796'
            }
          ]
        },
        {
          name: '法律(法学/非法学)',
          shortName: 'ky',
          id: 'BK202406180007',
          promotedAccount: '图书-摄友-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语（一）',
              worthid: 'd715e3b213194851abf2f65973131ca8',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '思想政治理论',
              worthid: 'b761d99bc207411b8a541a74f8b81992',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            },
            {
              name: '法律（法学）专业基础+综合',
              worthid: '389607c181d64b2e8eb474a0d6faf3df',
              subjectid: 'f7b205a2ec6542948686b7720e36a6ac'
            },
            {
              name: '法律（非法学）专业基础+综合',
              worthid: '60371610fa634c99817f3a01280af950',
              subjectid: '6a289a14a645473faa9bc443aa0acbc5'
            }
          ]
        },

        {
          name: '英语',
          shortName: 'ky',
          id: 'BK202406180009',
          promotedAccount: '图书-摄友-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语（一）',
              worthid: 'e6699f489d214dea93014275a40e1037',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            },
            {
              name: '英语（二）',
              worthid: 'c90b2a33d1cb4d42a6f0cb61dbb3457b',
              subjectid: '318bce61f95740d1aed00a31ea465d23'
            }
          ]
        },
        {
          name: '政治',
          shortName: 'ky',
          id: 'BK202406180010',
          promotedAccount: '图书-摄友-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '思想政治理论',
              worthid: '1476bcffcba547509ffa69ee646e28fd',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            }
          ]
        },
        {
          name: '数学',
          shortName: 'ky',
          id: 'BK202406180011',
          promotedAccount: '博慧轩图书-高数考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '数学（一）',
              worthid: '74bf8b58378a423c971247d89d5b86a3',
              subjectid: '6545d2a56d594562b7db97e65b44b667'
            },
            {
              name: '数学（二）',
              worthid: 'e01e324acd2049dfae2bf48a81a226ec',
              subjectid: '6d485fc3920042eb926718f7f77f5174'
            },
            {
              name: '数学（三）',
              worthid: '52a6cfc4171a439ca526d0d5be45c2c0',
              subjectid: '70e3a9f7a5b34c7bb6d3e587597a683c'
            }
          ]
        }
      ],
      bgImgList: {
        jzs2: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/sanwei/sanwei_jzs2_bg.jpg',
        jzs1: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/sanwei/sanwei_jzs1_bg.jpg',
        jzs2ydt: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/sxtsjzs2/sxts_jzs2_bg.jpg',
        aqs: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/sanwei/sanwei_aqs_bg.jpg',
        jjs: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/sanwei/sanwei_jjs_bg.jpg',
        ky: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/bhx-xm/bhx_xm_ky_bg.jpg'
      },
      id: '',
      shortName: '',
      currentCourse: {},
      //发送验证码
      isCodeClickable: true,
      isShow: false,
      filterList: []
    }
  },
  methods: {
    radioChange(index) {
      this.filterList.forEach(item => (item.isSelected = false))
      const current = this.filterList[index]
      current.isSelected = true
      this.$set(this.filterList, index, current)
    },
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      if (!this.filterList.find(item => item.isSelected)) {
        this.$toast.center('请选择科目')
        return
      } else {
        this.currentCourse = this.filterList.find(item => item.isSelected)
      }

      const gt = new Date().getTime().toString()
      enrollPwd({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        classid: this.currentCourse.id,
        subjectid: this.currentCourse.subjectList.map(item => item.subjectid).join(','),
        worthid: this.currentCourse.subjectList.map(item => item.worthid).join(','),
        collegeName: this.currentCourse.collegeName,
        orign: '图书',
        promotedAccount: `${this.currentCourse.promotedAccount}`,
        promotednum: this.$route.params.promotednum || '00'
      }).then(res => {
        this.$toast.center('提交成功')
        this.formData.mobile = ''
        this.formData.msg = ''
      })
    }
  },
  created() {
    this.shortName = this.$route.params.name
    this.filterList = this.list.filter(item => item.shortName === this.shortName)
    if (this.filterList.length) {
      this.currentBg = this.bgImgList[this.shortName]
      this.isShow = true
    }
  }
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100vw;
  &::-webkit-scrollbar {
    display: none;
  }
  .img {
    position: absolute;
    width: 100vw;
    top: 0;
    vertical-align: bottom;
    z-index: 0;
  }
  .input-container {
    position: relative;
    height: 58vw;
    width: 100%;
    padding: 186vw 0 0;
    z-index: 1;

    .input-box {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 0 9.5vw;
      input {
        flex: 1;
        border: none;
        outline: none;
        padding-left: 10px;
        border: 1px solid #f1f8ff;
        border-radius: 4px;
        font-size: 12px;
        height: 41px;
        box-shadow: none;
        background: rgb(243, 244, 246);
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        color: #fff;
        font-size: 12px;
        width: 99px;
        height: 30px;
        border-radius: 5px;
        background: rgb(27, 102, 203);
        span {
          color: #fff;
        }
      }
    }
    .radio-wrapper {
      display: flex;
      flex-wrap: wrap;
      padding-left: 6vw;
      padding-top: 1.5vw;

      .radio-item {
        display: flex;
        &:not(:last-child) {
          margin-right: 5px;
        }
        img {
          width: 4.5vw;
          height: 4.5vw;
        }
        span {
          font-size: 12px;
          color: #666;
        }
      }
    }
    &.aqs {
      padding: 189vw 0 0;
      .radio-wrapper {
        padding-left: 9.5vw;
        padding-top: 0;
        .radio-item {
          margin-right: 0;
          margin-bottom: 1vw;
          width: 28vw;
          &:nth-child(5) {
            width: 35vw;
          }
        }
      }
    }
    &.jjs {
      padding: 174vw 0 0;
      .radio-wrapper {
        padding-left: 9.5vw;
        .radio-item {
          display: flex;
          justify-content: center;
          margin-right: 0;
          margin-bottom: 3vw;
          width: 30%;
          img {
            margin-right: 3px;
          }
          &:nth-child(1) {
            width: 50%;
          }
          &:nth-child(1) {
            width: 50%;
          }
        }
      }
    }
    &.jzs1 {
      padding: 180vw 0 0;
    }
    &.jzs2ydt {
      padding: 170vw 0 0;
    }

    &.ky {
      padding: 145vw 0 0;
      .radio-wrapper {
        padding-left: 7vw;
        .radio-item {
          width: 29%;
          margin-bottom: 2vw;
          margin-right: 0 !important;
          &:nth-child(6) {
            width: 33%;
          }
        }
      }
    }

    .submit {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      margin: 21px auto 0;
      color: #fff;
      font-size: 14px;
      border-radius: 2px;
      height: 100%;
      width: 90%;
      background: none;
    }
  }
}
</style>
